var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectTool(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75448 1.11426H9.8727M13.3046 3.17337V1.11426H11.2454M4.38174 1.11426H2.32263V3.17337M2.32263 10.0371V12.0962H4.38174M13.3046 4.54611V7.29159M2.32263 8.66433V4.54611M13.4336 13.7929L11.2454 15.528L8.84315 12.4394L6.78404 14.8417L5.06811 5.23248L13.9909 9.69388L10.9023 10.7234L13.4336 13.7929Z",
    stroke: "#414141",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4729,
    height: 16.4729,
    fill: "#FBE5C6",
    transform: "translate(0.26355 0.427979)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectTool);
export default __webpack_public_path__ + "static/media/select-tool.9ab21b97e0ff6689a7889c41e303d377.svg";
export { ForwardRef as ReactComponent };